<script setup lang="ts">
    import { computed, useTemplateRef } from 'vue';
    import { useElementSize } from '@vueuse/core';

    // Preserve the logical layout to prevent clipping at narrow widths.
    // The rendered height limit also scales this layout down on desktop.
    const minimumSceneWidth = 640;
    const viewport = useTemplateRef<HTMLElement>('viewport');
    const { width } = useElementSize(viewport);
    const sceneWidth = computed(() => Math.max(minimumSceneWidth, width.value));
    const sceneStyle = computed(() => ({
        '--quiz-scene-width': `${sceneWidth.value}px`,
        '--quiz-scene-scale': width.value / sceneWidth.value
    }));
</script>

<template>
    <div
        ref="viewport"
        class="quiz-viewport"
    >
        <div
            class="quiz-scene"
            :style="sceneStyle"
        >
            <slot />
        </div>
    </div>
</template>

<style scoped>
    .quiz-viewport {
        position: relative;
        width: 100%;
        aspect-ratio: 9 / 16;
        overflow: hidden;
    }

    .quiz-scene {
        position: absolute;
        top: 0;
        left: 0;
        width: var(--quiz-scene-width);
        aspect-ratio: 9 / 16;
        transform: scale(var(--quiz-scene-scale));
        transform-origin: top left;
    }

    @media (prefers-reduced-motion: reduce) {
        .quiz-scene :deep(*) {
            animation: none !important;
            transition: none !important;
        }
    }
</style>
